import { render, staticRenderFns } from "./PlanPrices.vue?vue&type=template&id=47f7c060&"
import script from "./PlanPrices.vue?vue&type=script&lang=js&"
export * from "./PlanPrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports